import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const logo = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/New-Gladiators-Logo.jpg";

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`navbar ${isOpen ? "navbar-expanded" : ""}`}>
      <div className="navbar-logo">
        <img src={logo} alt="Gladiators FC Logo" className="logo-image" />
        Gladiators Football Team
      </div>
      <div className={`navbar-links ${isOpen ? "active" : ""}`}>
        <a href="/">Home</a>
        <a href="/about">About</a>
        <a href="/team">Team</a>
        <a href="/gallery">Gallery</a>
        <a href="/contact">Contact</a>
      </div>
      <div className="navbar-toggle" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
};

export default Navbar;
